import claimService from 'services/claim.service'

const state = {
    logins: [],
    tours: [],
    hotels: [],
    chats: [],
    filters: [],
    claims: [],
    loading: false,
    currentFilterParams: null
}

const getters = {
    getClaimById: (state) => (claimId) => {
        return state.claims.find(c => c.main.claim_id == claimId)
    },
    getClaimsCount: (state) => {
        return state.claims.length
    }
}

const mutations = {
    setRead(state, messageId) {
        for (const claim of state.claims) {
            const message = claim.messages.find(msg => msg.id == messageId);
            if (message) {
                message.is_read = 1;
                return;
            }
        }
    },
    setLogins(state, logins = []) {
        state.logins = logins;
    },
    setTours(state, tours = []) {
        state.tours = tours;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setChats(state, chats = []) {
        state.chats = chats;
    },
    setFilters(state, filters = []) {
        state.filters = filters;
    },
    setClaims(state, claims = []) {
        state.claims = claims;
    },
    setLoadind(state, loading = false) {
        state.loading = loading;
    },
    setCurrentFilterParams(state, params) {
        state.currentFilterParams = params;
    },
    updateClaimCancelDate(state, { claimId, cancelDate, canceledOrderIds }) {
        const claim = state.claims.find(c => c.main.claim_id == claimId);
        if (claim) {
            claim.main.cancel_date = cancelDate;
            claim.main.cancel_status = 'requested';

            if (claim.orders && Array.isArray(claim.orders)) {
                claim.orders.forEach(order => {
                    if (!canceledOrderIds || canceledOrderIds.includes(order.service_inc)) {
                        order.is_canceled = true;
                        order.status = 'cancelled';
                        order.lastcancelsale = cancelDate;
                    }
                });
            }

            if (claim.main && claim.main.status_name !== 'cancelled') {
                const allCanceled = claim.orders.every(order => order.is_canceled);
                if (allCanceled) {
                    claim.main.status_name = 'cancelled';
                }
            }
        }
    },
    updateClaimOrders(state, { claimId, orders }) {
        const claim = state.claims.find(c => c.main.claim_id == claimId);
        if (claim) {
            claim.orders = orders;
        }
    },
    updateSingleClaim(state, updatedClaim) {
        const index = state.claims.findIndex(c => c.main.claim_id == updatedClaim.main.claim_id);
        if (index !== -1) {
            state.claims[index] = updatedClaim;
        }
    },
    updateClaimFromResponse(state, { claimId, response }) {
        const claim = state.claims.find(c => c.main.claim_id == claimId);
        if (claim && response && response.success) {
            claim.main.cancel_date = response.cancel_date;
            if (claim.orders) {
                claim.orders.forEach(order => {
                    order.is_canceled = true;
                    order.status = 'cancelled';
                    order.lastcancelsale = response.cancel_date;
                });
            }
        }
    }
}

const actions = {
    clearResult({ commit }) {
        commit('setClaims', []);
        commit('setCurrentFilterParams', null);
    },

    getLogins({ commit }) {
        claimService.getLogins().then(response => {
            commit('setLogins', response);
        }).catch(() => {
        })
    },

    getTours({ commit }) {
        claimService.getTours().then(response => {
            commit('setTours', response);
        }).catch(() => {
        })
    },

    getHotels({ commit }) {
        claimService.getHotels().then(response => {
            commit('setHotels', response);
        }).catch(() => {
        })
    },

    getChats({ commit }) {
        claimService.getChats().then(response => {
            commit('setChats', response);
        }).catch(() => {
        })
    },

    getFilters({ commit }) {
        claimService.getFilters().then(response => {
            commit('setFilters', response);
        }).catch(() => {
        })
    },

    getClaims({ commit }, params) {
        commit('setLoadind', true);
        commit('setCurrentFilterParams', params);

        return new Promise((resolve, reject) => {
            claimService.getClaims(params).then(response => {
                commit('setClaims', response);
                commit('setLoadind', false);
                resolve(response);
            }).catch((error) => {
                commit('setLoadind', false);
                reject(error);
            })
        });
    },

    setRead({ commit }, params) {
        return new Promise((resolve, reject) => {
            claimService.setRead(params)
                .then((response) => {
                    commit('setRead', params.chatId);
                    resolve(response);
                })
                .catch((error) => {
                    console.error('Error in setRead action:', error);
                    reject(error);
                });
        });
    },

    setCancelRequest({ commit }, params) {
        return new Promise((resolve, reject) => {
            claimService.setCancelRequest(params)
                .then((response) => {
                    if (response && response.success) {
                        commit('updateClaimCancelDate', {
                            claimId: params.claim,
                            cancelDate: response.cancel_date
                        });
                    }
                    resolve(response);
                })
                .catch((error) => {
                    console.error('Error in setCancelRequest action:', error);
                    reject(error);
                });
        });
    },

    updateClaimData({ commit }, { claimId, cancelDate }) {
        commit('updateClaimCancelDate', { claimId, cancelDate });
    },

    async refreshCurrentClaims({ state, dispatch }) {
        if (state.currentFilterParams) {
            return await dispatch('getClaims', state.currentFilterParams);
        }
        return null;
    },

    async getClaimById({ getters }, claimId) {
        return getters.getClaimById(claimId);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
